import { Component, Input, OnInit, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-bitmask-field',
  templateUrl: './bitmask-field.component.html'
})

export class BitmaskField implements OnInit {
  @Input("listValues") listValues:Array<{
    code: string;
    id: string;
    name: string;
  }>;
  @Input("currentValue") currentValue:{
    code: string;
    value: string;
  };
  selectedValuesModel:Array<string> = [];
  @Output() onChange = new EventEmitter<any>();
  ngOnInit(){
    //переводим в двоичный код 
    let bin_number = this.dec2bin(parseInt(this.currentValue.value))

    //переворачиваем число с двоичным кодом
    let array_init = bin_number.split("").reverse();

    let array_pos = [];
    let end_array = [];

    //находим позиции где есть 1
    array_init.map((item,index)=>{
        if(parseInt(item)) array_pos.push(index)
    })

    //возводим в 2 степень
    array_pos.map(item=>{
        end_array.push(Math.pow(2, item))
    })

    //находим выбранные значения из списка значений
    this.listValues.map(item=>{
        if(end_array.indexOf(parseInt(item.code))>=0){
            this.selectedValuesModel.push(item.code)
        }
    })
  }
  onChangeSelect(){
      let summ = 0;
      this.selectedValuesModel.map(item=>{
        summ+=parseInt(item);
      })
      this.onChange.emit(summ);

  }

    dec2bin(dec:number){
        //переводим в довичный код
        return (dec >>> 0).toString(2);
    }
}



// WEBPACK FOOTER //
// ./src/app/view/components/bitmask-field/bitmask-field.component.ts